export default __webpack_public_path__ + "static/media/bottomSemiCircle.7c092522.svg";